<div class="row">
    <div class="col">
        <h6 class="font-weight-lighter f-18 cursor-default">{{ 'orgnotification.header' | trans }}</h6>
        <p class="cursor-default font-weight-light">{{ 'orgnotification.subheader' | trans }}</p>
    </div>
    <div class="col-auto float-right">
        <a class="cursor-pointer opacity" matTooltip="{{ 'orgnotification.addnotification' | trans }}"
            matTooltipPosition="above" data-toggle="modal" data-target="#createnotificationmodal">
            <span class="material-icons bg-lightgrey p-2 f-24 rounded-circle text-secondary zoom">
                add
            </span>
        </a>
    </div>
</div>
<div *ngFor="let notification of notificationlist" class="row hover-row">
    <div data-toggle="modal" data-target="#detailsTemplateModal" class="col">
        <p class="lh-40 mb-0 align-middle font-weight-light cursor-pointer" style="margin-left:5px;">{{
            notification.title
            }}</p>
    </div>
    <div data-toggle="modal" data-target="#detailsTemplateModal" class="col">
        <p class="lh-40 mb-0 align-middle cursor-pointer" style="text-align: center;">{{ 'orgtemplatelist.state' | trans
            }}{{ notification.templatestate }}</p>
    </div>
    <div data-toggle="modal" data-target="#detailsTemplateModal" class="col">
        <p class="lh-40 mb-0 align-middle cursor-pointer" style="text-align: center;">{{ 'orgtemplatelist.created' |
            trans }}{{ notification.created | date: 'yyyy-MM-dd'}}</p>
    </div>
    <div class="col">
        <span data-toggle="modal" data-target="#deleteTemplateModal" matTooltip="{{ 'orgtemplatelist.delete' | trans }}"
            matTooltipPosition="above" matTooltipShowDelay="500"
            class="material-icons rounded-circle lh-40 align-middle zoom w-40 pl-2 text-center cursor-pointer opacity-reverse float-right">
            delete
        </span>
    </div>
</div>

<!-- Create Modal -->
<div class="modal fade" id="createnotificationmodal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">{{ 'orgtemplatelist.delete' | trans }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="form-group">
                        <label for="exampleInputEmail1">Notification Title</label>
                        <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                            placeholder="Enter email">
                        <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone
                            else.</small>
                    </div>
                    <div class="form-group mb-1">
                        <label for="exampleFormControlTextarea1">Email markup</label>
                        <textarea class="form-control" placeholder="Email markup here..." id="textareamarkup"
                            rows="3"></textarea>
                    </div>
                    <button class="btn" (click)="showpreview()">
                        <p class="btn-text mb-0">View preview</p>
                    </button>
                </form>
                <ng-container *ngIf="previewhtml != undefined">
                    <p class="mb-1 mt-3">Preview</p>
                    <div class="border mt-2" style="border-style: dotted;">
                        <quill-view-html class="text-dark quill-no-pad" [content]="previewhtml"
                            theme="snow"></quill-view-html>
                    </div>
                </ng-container>
                <div class="row mt-3">
                    <div class="col">
                        <button type="button" class="btn-close" data-dismiss="modal">
                            <h6 class="btn-save-text">Cancel</h6>
                        </button>
                    </div>
                    <div class="col">
                        <button type="button" class="btn-save" data-dismiss="modal">
                            <h6 class="btn-save-text">Save</h6>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>